import { CircularProgress } from '@mui/material'
import React, { type FunctionComponent } from 'react'

export const AppLoader: FunctionComponent = () => {
	return (
		<div>
			<CircularProgress />
		</div>
	)
}
